import { combineReducers } from 'redux';
import networkZoneReducer from './store/networkZoneReducer';

export const reducers = combineReducers({
    networkZones: networkZoneReducer
});